<script setup>
import { computed, ref } from 'vue';
import { useI18n } from 'vue-i18n';
import { usePipelinesStore } from 'dashboard/stores/pipelines';

import Dialog from 'dashboard/components-next/dialog/Dialog.vue';
import PipelineStageAccordion from 'dashboard/components-next/Deals/PipelineStageAccordion.vue';

defineProps({
  isLoading: { type: Boolean, default: false },
});

const emit = defineEmits(['confirm']);

const { t } = useI18n();
const pipelinesStore = usePipelinesStore();
const allPipelines = computed(() => pipelinesStore.getPipelinesList);

const dialogRef = ref(null);
const selectedStageId = ref(null);

const open = () => {
  selectedStageId.value = null;
  dialogRef.value?.open();
};

const close = () => dialogRef.value?.close();

const handleConfirm = () => {
  if (!selectedStageId.value) return;
  emit('confirm', selectedStageId.value);
};

defineExpose({ open, close });
</script>

<template>
  <Dialog
    ref="dialogRef"
    :title="t('DEALS_BULK_ACTIONS.CHANGE_STAGE_DIALOG.TITLE')"
    :description="t('DEALS_BULK_ACTIONS.CHANGE_STAGE_DIALOG.DESCRIPTION')"
    :confirm-button-label="t('DEALS_BULK_ACTIONS.CHANGE_STAGE_DIALOG.CONFIRM')"
    :disable-confirm-button="!selectedStageId"
    :is-loading="isLoading"
    @confirm="handleConfirm"
  >
    <PipelineStageAccordion
      v-model="selectedStageId"
      :pipelines="allPipelines"
      :placeholder="t('DEALS_BULK_ACTIONS.CHANGE_STAGE')"
    />
  </Dialog>
</template>
